import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Header from './Header';
import PF2MTable from '~/components/PF2MTable';
import { useTranslation } from 'react-i18next';
import styles from '../styles';
import {
  getEquipmentTypes,
  getEquipmentsGroups,
} from '~/store/manager/actions';
import {
  getRpmRanges, importRpmRanges, exportRpmRanges, getRpmRangesTemplate,
} from '~/store/telemetry/actions';
import PF2MSearchSelectOutlined from '~/components/PF2MSearchSelectOutlined';

const RpmRangesTab = ({ classes }) => {
  const { t: translate } = useTranslation();
  const dispatch = useDispatch();
  const [dataLoaded, setDataLoaded] = useState(false);
  const [equipmentType, setEquipmentType] = useState(0);
  const [equipmentGroup, setEquipmentGroup] = useState(0);
  const equipmentTypes = useSelector(state => state.manager.equipmentTypes);
  const equipmentGroups = useSelector(state => state.manager.equipmentsGroups);
  const rpmRanges = useSelector(state => state.telemetry.rpmRanges);

  useEffect(() => {
    async function fetchData() {
      await dispatch(getEquipmentTypes());
      await dispatch(getEquipmentsGroups());
    }
    if (!dataLoaded) {
      fetchData();
      setDataLoaded(true);
    }
  }, [dataLoaded, dispatch]);

  useEffect(() => {
    async function fetchData() {
      await dispatch(getRpmRanges(equipmentType, equipmentGroup));
    }
    if (equipmentType > 0 && equipmentGroup > 0) {
      fetchData();
    }
  }, [equipmentType, equipmentGroup, dispatch]);

  const columns = [
    { field: 'equipament_group_name', title: translate('common:EquipmentGroup') },
    { field: 'group_equipament_links_name', title: translate('common:Equipment') },
    { field: 'rpm_no_rotation', title: translate('common:RpmNoRotation') },
    { field: 'low_gear_rpm', title: translate('common:RpmSlowRunning') },
    { field: 'high_spin_rpm', title: translate('common:RpmHighSpin') },
    { field: 'operation_rpm', title: translate('common:RpmOperation') },
  ];

  const renderItems = (items = []) => [{ value: 0, label: translate('common:Select') }]
    .concat(...items
      .map(e => ({ value: e.id, label: e.name })));

  const prepareData = data => data
    .map(r => ({
      ...r,
      rpm_no_rotation: '0',
    }))
    .filter(r => r.equipament_group_id === equipmentGroup);

  return (
    <div className={classes.tabContainer}>
      <Header
        importAction={file => dispatch(importRpmRanges(file))}
        exportAction={() => dispatch(exportRpmRanges())}
        getTemplateAction={() => dispatch(getRpmRangesTemplate())}
      />
      <div className={classes.containerTypeSelector}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span className={classes.labelTypeSelector}>
            {`${translate('common:EquipmentType')}:`}
          </span>
          <PF2MSearchSelectOutlined
            value={equipmentType}
            onChange={(e) => {
              setEquipmentType(e.target.value);
              setEquipmentGroup(0);
            }}
            className={classes.typeSelector}
          >
            {renderItems(equipmentTypes)}
          </PF2MSearchSelectOutlined>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
          <span className={classes.labelTypeSelector}>
            {`${translate('common:EquipmentGroup')}:`}
          </span>
          <PF2MSearchSelectOutlined
            value={equipmentGroup}
            onChange={e => setEquipmentGroup(e.target.value)}
            className={classes.typeSelector}
          >
            {renderItems(equipmentGroups.filter(e => e.id_equipament === equipmentType))}
          </PF2MSearchSelectOutlined>
        </div>
      </div>
      <PF2MTable
        data={prepareData(rpmRanges)}
        columns={columns}
        className={classes.grid}
      />
    </div>
  );
};

RpmRangesTab.propTypes = {
  classes: PropTypes.object.isRequired,
};

RpmRangesTab.defaultProps = {
};

export default withStyles(styles)(RpmRangesTab);
